import { evaluate } from 'mathjs'
import moment from 'moment';
const _ = require('lodash');


const extract = ([beg, end]) => {
    const matcher = new RegExp(`${beg}(.*?)${end}`, 'gm');
    const normalise = (str) => str.slice(beg.length, end.length * -1);
    return function (str) {
        if (str)
            return (str || "").match(matcher).map(normalise);
    }
}

export const Evaluate = (value, fieldValues, currentrefIds = [], dynamicData = [], sendActualVal = false) => {
    let fieldKeys = []
    let temp = value.toString()
    let tempsendActualVal = sendActualVal || false

    try {
        if ((currentrefIds && currentrefIds.length > 0) || Object.keys(dynamicData).length > 0) {
            fieldKeys = extract(['{{', '}}'])(value)
            fieldKeys && fieldKeys.forEach(each => {
                if (!fieldValues.hasOwnProperty(each)) {
                    let obj = dynamicData[each].find(each => each.refIds.includes(currentrefIds[0]))
                    temp = _.replace(temp, new RegExp(`{{${each}}}`, "g"), obj.value || 0)
                }
                else temp = _.replace(temp, new RegExp(`{{${each}}}`, "g"), fieldValues[each] || 0)
            })
        }
        else if (temp === '{{PolicyEnd}}<{{SpecifiedCompletionDate}}' || temp === '{{EXPIRY_DATE}}>{{CURRENT_DATE}}') {
            tempsendActualVal = true;
            let tempVal = temp
            fieldKeys = extract(['{{', '}}'])(value)
            fieldKeys && fieldKeys.forEach(each => {
                if (each === 'CURRENT_DATE')
                    fieldValues['CURRENT_DATE'] = moment(new Date()).format('MM/DD/YYYY')
                if (!fieldValues.hasOwnProperty(each)) {
                    let obj = dynamicData[each].find(each => each.refIds.includes(currentrefIds[0]))
                    tempVal = _.replace(tempVal, new RegExp(`{{${each}}}`, "g"), obj.value || 0)
                }
                else tempVal = _.replace(tempVal, new RegExp(`{{${each}}}`, "g"), fieldValues[each] || 0)
            })
            if (tempVal.includes('<')) {
                let splittemp = tempVal.split('<')
                var d1 = new Date(splittemp[0]);
                var d2 = new Date(splittemp[1]);
                if (d1.getTime() < d2.getTime()) {
                    temp = true
                }
            }
            else if (tempVal.includes('>')) {
                let splittemp = tempVal.split('>')
                var d1 = new Date(splittemp[0]);
                var d2 = new Date(splittemp[1]);
                if (d1.getTime() > d2.getTime()) {
                    temp = true
                }
            }
            else temp = false
        }
        else {
            fieldKeys = Object.keys(fieldValues);
            fieldKeys && fieldKeys.forEach(each => {
                //setting current user and current date (temp)
                if (temp === '{{CURRENT_USERID}}') {
                    temp = localStorage.getItem('profile') ? JSON.parse(localStorage.getItem('profile')).userId : ''
                    tempsendActualVal = true
                }
                else if (temp === '{{CURRENT_USERNAME}}') {
                    temp = localStorage.getItem('profile') ? JSON.parse(localStorage.getItem('profile')).name : ''
                    tempsendActualVal = true
                }
                else if (temp === '{{CURRENT_DATE}}') {
                    temp = moment(new Date()).format('MM/DD/YYYY')
                    tempsendActualVal = true
                }
                else if (temp === '{{CURRENT_DATE_ONE_YEAR}}') {
                    let CurrentDate = moment(new Date()).format('MM/DD/YYYY')
                    temp = moment(CurrentDate).add(12, 'M').format('MM/DD/YYYY');
                    tempsendActualVal = true
                }
                else if (temp === '{{CURRENT_DATE_THREE_YEARS}}') {
                    let CurrentDate = moment(new Date()).format('MM/DD/YYYY')
                    temp = moment(CurrentDate).add(36, 'M').format('MM/DD/YYYY');
                    tempsendActualVal = true
                }
                else if (temp === '{{CUSTOM_ODOT_CLOCK}}') {
                    const date1 = new Date(fieldValues['DATE_RECEIVED'] ? fieldValues['DATE_RECEIVED'] : new Date().toLocaleDateString());//6/5
                    date1.setDate(date1.getDate() + 30); //07/05
                    const date2 = new Date();
                    const diffTime = Math.abs(date1 - date2);//58 days
                    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
                    temp = diffDays
                    tempsendActualVal = true
                }
                else if (temp === '{{CUSTOM_CUTOFFDATE_ARE}}') {
                    const date1 = new Date(fieldValues['DATE_RECEIVED'] ? fieldValues['DATE_RECEIVED'] : new Date().toLocaleDateString());//6/5
                    date1.setDate(date1.getDate() + 30);
                    temp = moment(date1).format('MM/DD/YYYY')
                    tempsendActualVal = true
                }
                else if (temp === '{{CUSTOM_CUTOFFDATE_DC_60}}') {
                    const date1 = new Date();
                    date1.setDate(date1.getDate() + 60);
                    temp = moment(date1).format('MM/DD/YYYY');
                    tempsendActualVal = true
                }
                else if (temp === '{{CUSTOM_CUTOFFDATE_DC_30}}') {
                    const date1 = new Date();
                    date1.setDate(date1.getDate() + 30);
                    temp = moment(date1).format('MM/DD/YYYY');
                    tempsendActualVal = true
                }
                //{{CUSTOM_CUTOFFDATE_DC_60}}
                //  {{CUSTOM_CUTOFFDATE_DC_30}}
                else if (temp === '{{CURRENT_DATETIME}}') {
                    temp = moment(new Date()).format('MM/DD/YYYY hh:mm a')
                    tempsendActualVal = true
                }
                else temp = _.replace(temp, new RegExp(`{{${each}}}`, "g"), fieldValues[each] || 0)
            })
        }
        let finalvalue = tempsendActualVal ? temp : evaluate(temp)
        if (finalvalue || finalvalue === false)
            if (isNaN(finalvalue) || finalvalue === true || finalvalue === false)
                return finalvalue //=== 0 ? 0 : finalvalue
            else return (finalvalue % 1 !== 0) ? finalvalue.toFixed(2) : finalvalue //Math.abs(
        else return finalvalue //=== 0 ? null : 0
    }
    catch (error) {
        if (temp && fieldValues && fieldValues['OverRideCalVal'] === undefined)
            return temp === true ? true : (temp ? temp : false)
        else return temp
        //// console.log(error)
    }
    // return 0
}

export const DynamicEvaluate = (each, fieldValues, dynamicData, fields) => {
    const { name, type, value } = each;
    let currentrefIds = [];
    if (fields && fields.length > 0 && fields.find(element => element === name)) {
        if (dynamicData[name] && dynamicData[name].length > 0 && type)
            return dynamicData[name].filter((dyn, index) => {
                // console.log(currentrefIds, "currentrefIds in calcualte")
                if ((dyn.value ? dyn.value : '') === (typeof value === 'number' ? value.toString() : value) && type === '=') {
                    currentrefIds = [...currentrefIds, dyn.refIds]
                    //  if (index === dynamicData[name].length)
                    return currentrefIds
                }
                else if (Number(dyn.value) !== Number(value) && type === '!=') {
                    currentrefIds = [...currentrefIds, dyn.refIds]
                    return currentrefIds
                }
                else if (type === ">") {
                    // console.log(value, dyn.value)
                    if (Number(value) > Number(dyn.value)) {
                        currentrefIds = [...currentrefIds, dyn.refIds]
                        // console.log("here on step 2 true", currentrefIds)
                        if (index === 1) {
                            localStorage.setItem("calCurrentRefIds", JSON.stringify(currentrefIds))
                            return currentrefIds
                        }
                    }
                    else if (index === 1 && currentrefIds.length > 0) {
                        // console.log("here on step 2 false", currentrefIds)
                        localStorage.setItem("calCurrentRefIds", JSON.stringify(currentrefIds))
                        return currentrefIds
                    }
                }
                else if (type === "<") {
                    // console.log(value, dyn.value)
                    if (Number(value) < Number(dyn.value)) {
                        currentrefIds = [...currentrefIds, dyn.refIds]
                        if (index === 1) {
                            localStorage.setItem("calCurrentRefIds", JSON.stringify(currentrefIds))
                            return currentrefIds
                        }
                    }
                    else if (index === 1 && currentrefIds.length > 0) {
                        // console.log("here on step 4 for more than 5000");
                        localStorage.setItem("calCurrentRefIds", JSON.stringify(currentrefIds))
                        return currentrefIds
                    }
                }
                else if (type === '<=') {
                    if (Number(value) <= Number(dyn.value)) {
                        if (currentrefIds && currentrefIds.length > 0)
                            currentrefIds = [...currentrefIds, ...dyn.refIds]
                        else currentrefIds = [...dyn.refIds]
                        if (dynamicData[name].length - 1 === index) {
                            localStorage.setItem("calCurrentRefIds", JSON.stringify(currentrefIds))
                            localStorage.setItem("ignoreFilter", true)
                            localStorage.setItem("checkCurrentRefids", true)
                            return currentrefIds
                        }
                    }
                    else if (dynamicData[name].length - 1 === index && currentrefIds.length > 0) {
                        localStorage.setItem("checkCurrentRefids", true)
                        localStorage.setItem("calCurrentRefIds", JSON.stringify(currentrefIds))
                        return currentrefIds
                    }
                    else {
                        localStorage.setItem("calCurrentRefIds", JSON.stringify(currentrefIds))
                        if (currentrefIds && currentrefIds.length > 0)
                            return currentrefIds
                    }

                }
                else if (Number(dyn.value) >= Number(value) && type === '>=') {
                    currentrefIds = [...currentrefIds[0], ...dyn.refIds]
                    return currentrefIds
                }
                else if (type === 'CE')
                    return Evaluate(value, fieldValues, [], dynamicData)
                // else if (currentrefIds.length === 0 && index === dynamicData[name].length - 1) {
                //     return [false, []];
                // }
                // else return [false, []];
            })
    }
    else {
        let temp = (value && value.toString()) || ''
        let tempString = {}
        let fieldKeys = extract(['{{', '}}'])(value)
        if (temp === '(({{SITE_ADT}}*{{AADT}})/1000000)<={{Table1.LesserValue}}') {
            let tempVal = temp
            fieldKeys = extract(['{{', '}}'])(value)
            fieldKeys && fieldKeys.forEach(each => {
                if (fieldValues.hasOwnProperty(each))
                    tempVal = _.replace(tempVal, new RegExp(`{{${each}}}`, "g"), fieldValues[each] || 0)
                else tempString['name'] = each
            })
            if (tempVal && tempVal.includes('<=')) {
                let splitArray = tempVal.split('<=');
                // console.log(evaluate(splitArray[0]))
                tempString['value'] = evaluate(splitArray[0])
                // console.log(tempString)
            }

        }
        else if (temp === '(({{LANDUSEADT_SUM#TotalLandUseADT}}*{{AADT}})/1000000)<={{Table1.LesserValue}}') {
            let tempVal = temp
            fieldKeys = extract(['{{', '}}'])(value)
            fieldKeys && fieldKeys.forEach(each => {
                if (fieldValues.hasOwnProperty(each))
                    tempVal = _.replace(tempVal, new RegExp(`{{${each}}}`, "g"), fieldValues[each] || 0)
                else tempString['name'] = each
            })
            if (tempVal && tempVal.includes('<=')) {
                let splitArray = tempVal.split('<=');
                // console.log(evaluate(splitArray[0]))
                tempString['value'] = evaluate(splitArray[0])
                // console.log(tempString)
            }

        }
        else {
            fieldKeys && fieldKeys.forEach(each => {
                if (fieldValues.hasOwnProperty(each)) {
                    _.replace(temp, new RegExp(`{{${each}}}`, "g"), fieldValues[each] || 0)
                    tempString['value'] = fieldValues[each]
                }
                else tempString['name'] = each
            })
        }
        if (temp) {
            if (temp.includes('>=')) {
                tempString['type'] = '>='
            }
            else if (temp.includes('<=')) {
                tempString['type'] = '<='
            }
            else if (temp.includes('>')) {
                tempString['type'] = '>'
            }
            else if (temp.includes('<')) {
                tempString['type'] = '<'
            }
            else if (temp.includes('=')) {
                tempString['type'] = '='
            }
        }
        let data = DynamicEvaluate(tempString, fieldValues, dynamicData, fieldKeys.filter(e => !fieldValues[e]))
        //  // console.log(data, currentrefIds, "data is here to send return ")
        let localCurrentRefIds = localStorage.getItem("calCurrentRefIds") ? JSON.parse(localStorage.getItem("calCurrentRefIds")) : []
        let ignoreFilter = localStorage.getItem("ignoreFilter") ? true : false
        if (localCurrentRefIds.length > 0) {
            // console.log("localstorage")
            if (localCurrentRefIds.length === 1 || ignoreFilter) {
                localStorage.removeItem("calCurrentRefIds")
                localStorage.removeItem("ignoreFilter")
                return ignoreFilter ? localCurrentRefIds : localCurrentRefIds[0]
            }
            else {
                let temp = [];
                localCurrentRefIds.forEach(each => {
                    temp = [...temp, ...each]
                })
                temp.filter((item,
                    index) => temp.indexOf(item) === index);
                localStorage.removeItem("calCurrentRefIds")
                return temp
            }
        } else
            if (data && data[0])
                return data[0].refIds
    }
}

